var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", lg: _vm.lgSize } },
        [
          _c(
            "app-price-item",
            {
              attrs: {
                pricing: _vm.pricing,
                "show-price-type": _vm.selectedFrequencyType,
                tier: 0,
                "current-plan": _vm.currentPlan,
                "has-no-plan": _vm.hasNoPlan,
              },
            },
            [
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[0]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[1]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[2]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[3]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[4]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.starter[5]"))),
              ]),
              _vm.selectedFrequencyType == 2
                ? _c("app-item-option", [
                    _vm._v(" " + _vm._s(_vm.$ct("features.starter[7]")) + " "),
                  ])
                : _vm._e(),
              _vm.selectedFrequencyType != 2
                ? _c("app-item-option", { staticClass: "support" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("features.starter[6]")) + " "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", lg: _vm.lgSize } },
        [
          _c(
            "app-price-item",
            {
              attrs: {
                pricing: _vm.pricing,
                "show-price-type": _vm.selectedFrequencyType,
                tier: 1,
                "most-often-chosen": "",
                "current-plan": _vm.currentPlan,
                "has-no-plan": _vm.hasNoPlan,
              },
            },
            [
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.professional[0]")) + " "),
              ]),
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.professional[1]")) + " "),
              ]),
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.professional[2]")) + " "),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.professional[3]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.professional[4]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.professional[5]"))),
              ]),
              _vm.selectedFrequencyType == 2
                ? _c("app-item-option", [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("features.professional[7]")) + " "
                    ),
                  ])
                : _vm._e(),
              _vm.selectedFrequencyType != 2
                ? _c("app-item-option", { staticClass: "support" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("features.professional[6]")) + " "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", lg: _vm.lgSize } },
        [
          _c(
            "app-price-item",
            {
              attrs: {
                pricing: _vm.pricing,
                "show-price-type": _vm.selectedFrequencyType,
                tier: 2,
                "current-plan": _vm.currentPlan,
                "has-no-plan": _vm.hasNoPlan,
              },
            },
            [
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.enterprise[0]")) + " "),
              ]),
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.enterprise[1]")) + " "),
              ]),
              _c("app-item-option", { attrs: { bold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.enterprise[2]")) + " "),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.enterprise[3]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.enterprise[4]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.enterprise[5]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.enterprise[6]"))),
              ]),
              _c("app-item-option", [
                _vm._v(_vm._s(_vm.$ct("features.enterprise[7]"))),
              ]),
              _c(
                "app-item-option",
                [
                  _c(
                    "w-link",
                    {
                      attrs: {
                        to: "https://winfakt.be/modules",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("features.enterprise[8]")))]
                  ),
                ],
                1
              ),
              _c("app-item-option", { attrs: { gold: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("features.enterprise[9]")) + " "),
              ]),
              _c("app-item-option", { attrs: { additional: "" } }, [
                _vm._v(_vm._s(_vm.$ct("features.additional[0]"))),
              ]),
              _c("app-item-option", { attrs: { additional: "" } }, [
                _vm._v(_vm._s(_vm.$ct("features.additional[1]"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }